import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "InvoiceBasicDeliveryHistory" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "InvoiceBasicDeliveryHistory__title" }, "История доставки", -1)
const _hoisted_3 = { class: "InvoiceBasicDeliveryHistory__body" }
const _hoisted_4 = {
  key: 0,
  class: "body__center"
}
const _hoisted_5 = {
  key: 1,
  class: "body__center"
}
const _hoisted_6 = { class: "body__fail" }
const _hoisted_7 = /*#__PURE__*/_createVNode("span", null, "Произошла ошибка при получении истории доставки", -1)
const _hoisted_8 = {
  key: 0,
  class: "body__center"
}
const _hoisted_9 = /*#__PURE__*/_createVNode("p", null, "История доставки не найдена", -1)
const _hoisted_10 = {
  key: 1,
  class: "body__statuses"
}
const _hoisted_11 = { class: "status__name" }
const _hoisted_12 = { class: "status__state" }
const _hoisted_13 = { class: "state__date" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_s_loader = _resolveComponent("s-loader")!
  const _component_icon_refresh = _resolveComponent("icon-refresh")!
  const _component_icon_status_waiting = _resolveComponent("icon-status-waiting")!
  const _component_icon_status_in_progress = _resolveComponent("icon-status-in-progress")!
  const _component_icon_status_completed = _resolveComponent("icon-status-completed")!
  const _component_icon_status_canceled = _resolveComponent("icon-status-canceled")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      (_ctx.invoiceStatuses.state.is_loading)
        ? (_openBlock(), _createBlock("div", _hoisted_4, [
            _createVNode(_component_s_loader)
          ]))
        : (_ctx.invoiceStatuses.state.is_failed)
          ? (_openBlock(), _createBlock("div", _hoisted_5, [
              _createVNode("div", _hoisted_6, [
                _hoisted_7,
                _createVNode(_component_icon_refresh, { class: "fail__refresh" })
              ])
            ]))
          : (_ctx.invoiceStatuses.state.is_done)
            ? (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
                (!_ctx.isSuccess)
                  ? (_openBlock(), _createBlock("div", _hoisted_8, [
                      _hoisted_9
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_10, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.invoiceStatuses.state.data.data.status_history, (status, i) => {
                        return (_openBlock(), _createBlock("div", {
                          class: "status",
                          key: `LTLInvoiceStatus-${i}`
                        }, [
                          _createVNode("span", _hoisted_11, _toDisplayString(_ctx.getStatusName(status)), 1),
                          _createVNode("div", _hoisted_12, [
                            (status.state === _ctx.LTL_STATUS_WAITING_TOKEN)
                              ? (_openBlock(), _createBlock(_component_icon_status_waiting, {
                                  key: 0,
                                  class: "state__icon"
                                }))
                              : _createCommentVNode("", true),
                            (status.state === _ctx.LTL_STATUS_IN_PROGRESS_TOKEN)
                              ? (_openBlock(), _createBlock(_component_icon_status_in_progress, {
                                  key: 1,
                                  class: "state__icon"
                                }))
                              : _createCommentVNode("", true),
                            (status.state === _ctx.LTL_STATUS_COMPLETED_TOKEN)
                              ? (_openBlock(), _createBlock(_component_icon_status_completed, {
                                  key: 2,
                                  class: "state__icon"
                                }))
                              : _createCommentVNode("", true),
                            (status.state === _ctx.LTL_STATUS_CANCELED_TOKEN)
                              ? (_openBlock(), _createBlock(_component_icon_status_canceled, {
                                  key: 3,
                                  class: "state__icon"
                                }))
                              : _createCommentVNode("", true),
                            _createVNode("p", _hoisted_13, [
                              (Boolean(status.date))
                                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode(_toDisplayString(status.date), 1)
                                  ], 64))
                                : (Boolean(status.predict_date))
                                  ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                                      _createTextVNode(_toDisplayString(status.predict_date), 1)
                                    ], 64))
                                  : _createCommentVNode("", true)
                            ])
                          ])
                        ]))
                      }), 128))
                    ]))
              ], 64))
            : _createCommentVNode("", true)
    ])
  ]))
}